import React from 'react';

import FontAwesome from 'react-fontawesome';
import Slider, { CustomArrowProps, Settings } from 'react-slick';

import Log from 'providers/log';

import fallBackImage from 'assets/images/imagecache_defaults.png';

import './SlickCarousel.sass';

type FontAwesomeArrowProps =  CustomArrowProps & { name: string; size: FontAwesome.FontAwesomeSize; };
const FontAwesomeArrow = ({ className, style, onClick, name, size }: FontAwesomeArrowProps) => (
    <FontAwesome className={className} onClick={onClick} name={name} size={size} style={style} />
);

const carouselSettings: Settings = {
    nextArrow: <FontAwesomeArrow name="angle-right" size="5x" />,
    prevArrow: <FontAwesomeArrow name="angle-left" size="5x" />,
    slidesToScroll: 1,
    slidesToShow: 4,
    speed: 500
};

const getNoSlideSettings = (count: number): Settings => {
    return {
        arrows: false,
        slidesToShow: count
    };
};

interface CarouselProps {
    imageSources: string[];
    onClick?: (index: number) => any;
}

const SlickCarousel: React.StatelessComponent<CarouselProps> = ({ imageSources, onClick: handleClick }) => {
    if (imageSources.length < 2) {
        Log.error('Unable to render carousel with less than 2 slides, nothing will be rendered', 'SlickCarousel.render()');
        return null;
    }
    return(
        <div className="slick-carousel">
            <Slider {...imageSources.length <= 4 ? getNoSlideSettings(imageSources.length) : carouselSettings}>
                {imageSources.map((image, index) => (
                    <div className="slide" key={index} onClick={() => handleClick && handleClick(index)}>
                        <div className="slide-image" style={{ backgroundImage: `url(${image}), url(${fallBackImage})` }} />
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default SlickCarousel;



// WEBPACK FOOTER //
// ./src/components/global/application/SlickCarousel.tsx